import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { onboardingAPI } from '../services/api';
import { STAGE_LABELS } from '../pages/onboarding/Onboarding';

const STAGE_ORDER = ['new_entry', 'tutor_suggestion', 'verification', 'demo_scheduled', 'demo_review', 'class_started'];

export default function OnboardingSummary({ limit = 5 }) {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    onboardingAPI.list().then(({ data }) => setRecords(data)).catch(() => setRecords([])).finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  const shown = records.slice(0, limit);

  return (
    <div className="card mt-6">
      <div className="card-header">
        <h3>Student Onboarding</h3>
        <Link to="/onboarding" className="link-sm">View all →</Link>
      </div>
      {shown.length === 0 ? (
        <div className="empty-state">No onboarding records. <Link to="/onboarding/new">Add a student</Link></div>
      ) : (
        <table className="data-table">
          <thead>
            <tr><th>Student</th><th>Status</th><th>Pending Stages</th></tr>
          </thead>
          <tbody>
            {shown.map((r) => {
              const idx = STAGE_ORDER.indexOf(r.stage);
              const complete = r.stage === 'class_started' && r.is_active;
              const pending = complete ? [] : STAGE_ORDER.slice(idx + 1);
              return (
                <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/onboarding/${r.id}`)}>
                  <td>
                    {r.student_name}
                    {r.reassignment_count > 0 && <span className="badge badge-purple ml-2">🔄</span>}
                    {r.is_on_hold && <span className="badge badge-red ml-2">Hold</span>}
                  </td>
                  <td>
                    {complete
                      ? <span className="badge badge-green">Onboarding Completed ✅</span>
                      : <span className="badge badge-orange">Current: {STAGE_LABELS[r.stage]}</span>}
                  </td>
                  <td className="text-muted" style={{ fontSize: 13 }}>
                    {pending.length === 0 ? '—' : pending.map((s) => STAGE_LABELS[s]).join(' · ')}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
